;(() => {
  if (window.HTMLUpdateUtility) return

  const safeRunCallbacks = (callbacks = [], context) => {
    callbacks.forEach((callback) => {
      try {
        callback(context)
      } catch (error) {
        console.error('HTMLUpdateUtility callback error', error)
      }
    })
  }

  const replaceNode = (source, replacementTemplate) => {
    if (!source || !replacementTemplate) return null
    const replacement = replacementTemplate.cloneNode(true)
    source.replaceWith(replacement)
    return replacement
  }

  const runTransition = (fn) => {
    if (typeof document.startViewTransition === 'function') {
      document.startViewTransition(() => fn())
    } else {
      fn()
    }
  }

  window.HTMLUpdateUtility = {
    viewTransition(
      source,
      destination,
      preProcessCallbacks = [],
      postProcessCallbacks = [],
    ) {
      if (!source || !destination) return

      const templateNode = destination.cloneNode(true)
      safeRunCallbacks(preProcessCallbacks, templateNode)

      runTransition(() => {
        const newNode = replaceNode(source, templateNode)
        safeRunCallbacks(postProcessCallbacks, newNode)
      })
    },

    setInnerHTML(target, html) {
      if (!target) return
      target.innerHTML = html
    },
  }
})()
